import React, { useContext } from "react";
import { Button, message, Modal } from "antd";
import style from "./index.module.scss";
import {
    activityListItem,
    GroupType,
    publishGroupActivity,
    PublishStatus
} from "../../../../../service/group";
import { useSetAtom } from "jotai";
import { FlagAtom } from "../../store";
import { errorMessage } from "service/service";
import { ResultMessage } from "components/ResultMessage";
import DeleteConfirm from "components/DeleteConfirm";
import { courseProjectionUrl } from "../../../../../service/url";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../Store";
import moment from "moment";
import SubmitError from "components/SubmitError";
import useModalHandler from "../../../../../utils/v3/useModalHandler";
import ShowRandomModal from "../ShowRandomModal";
import useRequestFn from "../../../../../utils/useRequestFn";

interface ListLinksProps {
    item: activityListItem;
    status: string; //活动发布状态
    onEdit: () => void; //编辑
    onOk: () => void; //发布成功
    onDelete: () => void; //删除活动
    gotoReview: (id: number, params?: StringMap) => void; //跳转页面
}

export default function ListLinks({
    item,
    status,
    onEdit,
    onOk,
    onDelete,
    gotoReview
}: ListLinksProps) {
    const history = useHistory();
    const { course } = useContext(CourseContext);
    const updateFlag = useSetAtom(FlagAtom);

    const { activityBaseInfo, dcGroupActivityStatics } = item;

    //编辑
    const handleEdit = () => {
        updateFlag("edit");
        onEdit();
    };

    //发布
    const [onSubmit, { loading }] = useRequestFn(publishGroupActivity);
    const onPublish = async (status?: string) => {
        if (moment().isAfter(moment(activityBaseInfo.deadlineStr))) {
            Modal.confirm({
                title: `发布失败`,
                content: `请点击编辑按钮，调整截止时间后重新发布。`,
                onOk: async () => {}
            });
        } else {
            try {
                await onSubmit(activityBaseInfo.id, status);
                await onOk();
                message.success("发布成功");
            } catch (e) {
                ResultMessage.error(
                    <SubmitError title="发布失败" content={errorMessage(e)} />,
                    { duration: 2000, width: 300 }
                );
            }
        }
    };

    const showRandomModal = useModalHandler({
        component: ShowRandomModal
    });

    return (
        <div className={style.root}>
            {item.activityBaseInfo.groupType === GroupType.random && (
                <Button
                    type="link"
                    onClick={() =>
                        showRandomModal.open({
                            randomGroupKey:
                                item.activityBaseInfo.randomGroupKey!,
                            canEdit: status !== PublishStatus.Yes,
                            signInId: item.activityBaseInfo.signInId
                        })
                    }>
                    查看分组
                </Button>
            )}
            {status !== PublishStatus.Yes && (
                <>
                    {status !== PublishStatus.Waiting && (
                        <Button
                            type="link"
                            loading={loading}
                            onClick={() => onPublish()}>
                            发布
                        </Button>
                    )}
                    {status === PublishStatus.Waiting && (
                        <DeleteConfirm
                            okText="是"
                            cancelText="否"
                            title="如有小组完成作答，是否重置小组活动状态为未参与？"
                            onSuccess={() => onPublish("1")}
                            onCancel={() => onPublish()}>
                            <Button type="link" loading={loading}>
                                重新发布
                            </Button>
                        </DeleteConfirm>
                    )}
                    <Button type="link" onClick={handleEdit}>
                        编辑
                    </Button>
                    <Button type="link" onClick={onDelete}>
                        删除
                    </Button>
                </>
            )}
            {status === PublishStatus.Yes && (
                <>
                    {dcGroupActivityStatics.hasPartInCount !== 0 && (
                        <Button
                            type="link"
                            onClick={() =>
                                history.push(
                                    courseProjectionUrl(
                                        course.weekTimeId,
                                        `group/${activityBaseInfo.id}`
                                    )
                                )
                            }>
                            快速投屏
                        </Button>
                    )}
                    <Button
                        type="link"
                        onClick={() => gotoReview(activityBaseInfo.id)}>
                        批阅
                    </Button>
                </>
            )}

            {showRandomModal.render()}
        </div>
    );
}
